import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Dashboard from '../pages/Dashboard';
import Settings from '../pages/Settings';
import Stats from '../pages/Stats';
import Ranking from '../pages/Ranking';
import LoggedInLayout from '../pages/LoggedInLayout';
import Redirector from '../pages/Redirector';
import Training from '../pages/Training/Training';
import SessionView from '../pages/Training/SessionView';
import Classes from '../pages/Classes/Classes';
import ClassDetail from '../pages/Classes/ClassDetail';

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Redirector />} />
        <Route path="/" element={<LoggedInLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="ranking" element={<Ranking />} />
          <Route path="statystyki" element={<Stats/>} />
          <Route path="ustawienia" element={<Settings />} />
          <Route path="trening" element={<Training />} />
          <Route path="trening/sesja/:planId/:sessionId" element={<SessionView />} />
          <Route path="zajecia" element={<Classes />} />
          <Route path="zajecia/:instanceId" element={<ClassDetail />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes; 